import React, { useContext, useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { AccessGateContext } from "../../../context/accessGateContext";
import { useNavigate } from "react-router-dom";
import { featureFlags } from "../../../config/featureConfig";
import GraficiDashboard from "./grafici/grafici";

const Dashboard = () => {
  const { canAccessVendorArea } = useContext(AccessGateContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!canAccessVendorArea) {
      navigate("/");
    }
  }, [canAccessVendorArea, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
          <Stack spacing={0.5} sx={{ mb: 3 }}>
            <Typography
              sx={{
                fontFamily: "Rubik, sans-serif",
                fontWeight: 800,
                fontSize: { xs: "1.65rem", sm: "2rem" },
                color: "#0b3d87",
                letterSpacing: "-0.02em",
              }}
            >
              Dashboard
            </Typography>
            <Typography
              sx={{
                fontFamily: "Rubik, sans-serif",
                fontSize: "0.9375rem",
                color: "text.secondary",
                maxWidth: 560,
                lineHeight: 1.5,
              }}
            >
              Benvenuto nella tua area riservata di Wow Che Prezzi.
              <br />
              Qui puoi visualizzare i dati e statistiche del tuo E-Commerce.
            </Typography>
          </Stack>
   
        {featureFlags.enableDashboardCharts ? <GraficiDashboard /> : null}
    </Box>
  );
};

export default Dashboard;
